// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  
  production: typeof true !== 'undefined' ? true : false,
  apiLocalUrl: "https://servicios.bancoldex.com:31716/",
  idTagManager: 'GTM-PSHQHM6', // TAG MANAGER PRUEBAS
  tokenReCaptcha: '6Lc7cdItAAAAAOJyr8x8mwpkT-rwq8m_T1ZQwNMz', // Token de reCAPTCHA v2
  clarityEnabled: typeof true !== 'undefined' ? true : false, // habilita clarity en DEV
  clarityProjectId: 'ttac1us89o',
  consentRequired: typeof true !== 'undefined' ? true : false, // exige consentimiento para clarity
  /** Dominios permitidos para iframes (videos). Desde variable group: lista separada por coma. Token: www.youtube.com,youtube.com,www.youtube-nocookie.com,youtube-nocookie.com,youtu.be */
  allowedIframeHosts: 'www.youtube.com,youtube.com,www.youtube-nocookie.com,youtube-nocookie.com,youtu.be'
};